import { forwardRef, useState } from 'react';
import cn from 'classnames';

import Shape, { type ShapeType } from 'components/nysgjerrigper/shape/Shape';
import { getColor } from 'js/utils/np-colors';

const types: ShapeType[] = ['longH', 'snakeV', 'longV'];
const pickType = (): ShapeType => types[Math.floor(Math.random() * 10000) % types.length];

interface RandomShapesProps {
  index: number;
  blockIndex: number;
  stepIndex: number;
  style?: React.CSSProperties;
}

const RandomShapes = forwardRef<HTMLDivElement, RandomShapesProps>(({ index, blockIndex, stepIndex, style }, ref) => {
  const [randomType] = useState(pickType);
  const [coinFlip] = useState(() => Math.random() > 0.5);

  const colorIndex = index >= blockIndex ? stepIndex + index + 1 : stepIndex + index;

  const classes = () => {
    const isRight = index % 2 === 1;
    const isColumn = randomType === 'snakeV' || randomType === 'longV';
    return {
      'random-shapes--shapes--right': isRight,
      'random-shapes--shapes--right-horizontal': isRight && !isColumn,
      'random-shapes--shapes--column': isColumn,
      'random-shapes--shapes--reverse': coinFlip
    };
  };

  return (
    <div className="random-shapes" ref={ref}>
      <div className="random-shapes--parallax-scrolling" style={style}>
        <div className={cn('random-shapes--shapes', classes())}>
          <Shape
            className={cn('random-shapes--shapes-shape random-shapes--shapes-shape--long', randomType)}
            type={randomType}
            color={getColor(stepIndex)}
          />
          <Shape
            className="random-shapes--shapes-shape random-shapes--shapes-shape--circle"
            type="circle"
            color={getColor(colorIndex)}
          />
        </div>
      </div>
    </div>
  );
});

RandomShapes.displayName = 'RandomShapes';

export default RandomShapes;
